import globalToast from "../components/common/globalToast";
import api from "../services/api";

export async function signInAdmin(user, password) {
    const payload = { user, password };

    try {
        const response = await api.post('/auth.php', payload);
        return response.data;
    } catch (error) {
        console.log(error);
        globalToast.error("Houve um erro ao tentar acessar a conta! Tente novamente mais tarde.");
    };
};

export async function getUserData() {
    try {
        const response = await api.get('/auth.php');
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            return null;
        }
        console.log(error);
    };
};

export async function signOutAdmin() {
    try {
        await api.post('/auth.php', { action: 'logout' });
    } catch (error) {
        console.log(error);
    };
};
